//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.ViewProjectionPlaneBuilder.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CurvePoints",0,"Section",0],[0,"CurveTypeEdges",1,0],[0,"CurveTypePlane1",1,0],[0,"CurveTypePlane2",1,0],[0,"FromView",1,"View",0],[1,"Plane1",0,"Drawings.ViewProjectionPlaneBuilder",0],[1,"Plane2",0,"Drawings.ViewProjectionPlaneBuilder",0],[1,"ToViews",0,"Drawings.SelectDraftingViewList",0],[0,"Type",1,0]],[],[]];
SPLM.Drawings.ViewProjectionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewProjectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewProjectionBuilder.Types = Object.freeze({
    "ProjectOnOnePlane" : "ProjectOnOnePlane", "ProjectOnTwoPlanes" : "ProjectOnTwoPlanes"});

SPLM.Drawings.ViewProjectionBuilder.CurveType = Object.freeze({
    "Active" : "Active", "Reference" : "Reference", "None" : "None"});

export default SPLM;